import React, { useState, useEffect, useRef } from 'react';
import styles from './Coordinates.module.scss';
import ReactMapGL, { Marker } from 'react-map-gl';
import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

const Coordinates = ({ address, hours, phone, linkLinkedIn }) => {
  const coordinatesRef = useRef(null);

  const [viewport, setViewport] = useState({
    width: 'auto',
    height: 'auto',
    latitude: 49.44798435,
    longitude: 1.09731068,
    zoom: 12,
  });

  // Turn navbar in gradient
  useEffect(() => {
    ScrollTrigger.matchMedia({
      // desktop
      '(min-width: 800px)': function () {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: coordinatesRef.current,
            scrub: true,
            start: `top ${25 + 20 + 32}`,
            end: `top ${25 + 20}`,
          },
        });

        tl.to(
          '#t-menuHamburger div span:nth-child(1)',
          { background: 'var(--blue)', duration: 1 },
          0
        )
          .to(
            '#t-menuHamburger div span:nth-child(2)',
            { background: '#6462b8', duration: 1 },
            0
          )
          .to(
            '#t-menuHamburger div span:nth-child(3)',
            { background: 'var(--purple)', duration: 1 },
            0
          )
          .to(
            '#t-menuHamburger p',
            { color: 'var(--darkGrey)', duration: 1 },
            0
          )
          .to(
            '#logo',
            {
              '-webkit-filter': 'brightness(1)',
              filter: 'brightness(1)',
            },
            0
          )
          .to('#filArianne p', { color: 'var(--darkGrey)', duration: 1 }, 0);
      },

      // small
      '(min-width: 600px) and (max-width: 799px)': function () {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: coordinatesRef.current,
            scrub: true,
            start: `top ${20 + 20 + 32}`,
            end: `top ${20 + 20}`,
          },
        });

        tl.to(
          '#t-menuHamburger div span:nth-child(1)',
          { background: 'var(--blue)', duration: 1 },
          0
        )
          .to(
            '#t-menuHamburger div span:nth-child(2)',
            { background: '#6462b8', duration: 1 },
            0
          )
          .to(
            '#t-menuHamburger div span:nth-child(3)',
            { background: 'var(--purple)', duration: 1 },
            0
          )
          .to(
            '#t-menuHamburger p',
            { color: 'var(--darkGrey)', duration: 1 },
            0
          )
          .to(
            '#logo',
            {
              '-webkit-filter': 'brightness(1)',
              filter: 'brightness(1)',
            },
            0
          )
          .to('#filArianne p', { color: 'var(--darkGrey)', duration: 1 }, 0);
      },

      // mobile
      '(max-width: 599px)': function () {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: coordinatesRef.current,
            scrub: true,
            start: `top ${15 + 15 + 32}`,
            end: `top ${15 + 15}`,
          },
        });

        tl.to(
          '#t-menuHamburger div span:nth-child(1)',
          { background: 'var(--blue)', duration: 1 },
          0
        )
          .to(
            '#t-menuHamburger div span:nth-child(2)',
            { background: '#6462b8', duration: 1 },
            0
          )
          .to(
            '#t-menuHamburger div span:nth-child(3)',
            { background: 'var(--purple)', duration: 1 },
            0
          )
          .to(
            '#t-menuHamburger p',
            { color: 'var(--darkGrey)', duration: 1 },
            0
          )
          .to(
            '#logo',
            {
              '-webkit-filter': 'brightness(1)',
              filter: 'brightness(1)',
            },
            0
          )
          .to('#filArianne p', { color: 'var(--darkGrey)', duration: 1 }, 0);
      },
    });
  }, []);

  // add gradient background to nav tag
  useEffect(() => {
    ScrollTrigger.create({
      trigger: coordinatesRef.current,
      scrub: true,
      start: 'top',
      end: 'top',
      onEnter: () => {
        gsap.set('#nav', {
          duration: 1,
          background: `linear-gradient(180deg,
          rgba(255,255,255,1) 65%,
          rgba(255,255,255,0.9) 70%,
          rgba(255,255,255,0.6) 80%,
          rgba(255,255,255,0.5) 85%,
          rgba(255,255,255,0.0) 100%)
        `,
        });
      },
      onEnterBack: () => {
        gsap.set('#nav', {
          background: 'transparent',
        });
      },
    });
  }, []);

  return (
    <section className={styles.Coordinates} ref={coordinatesRef}>
      <div className={`${styles.Coordinates__content} layout row`}>
        <div className={styles.Coordinates__content__infos}>
          <h2>Rouen - Normandie</h2>
          <div className={styles.Coordinates__content__infos__divider}></div>

          <address>
            <div className={styles.Coordinates__content__infos__info}>
              <img
                width='30'
                height='30'
                src='/img/svg/footer/icn-phone.svg'
                alt=''
                role='presentation'
              />
              <p>{phone}</p>
            </div>
            <div className={styles.Coordinates__content__infos__info}>
              <img
                width='30'
                height='30'
                src='/img/svg/footer/icn-clock.svg'
                alt=''
                role='presentation'
              />
              <p>{hours}</p>
            </div>
            <div className={styles.Coordinates__content__infos__info}>
              <img
                width='30'
                height='30'
                src='/img/svg/footer/icn-card.svg'
                alt=''
                role='presentation'
              />
              <p>{address}</p>
            </div>
          </address>

          <a
            target={'_blank'}
            rel='noreferrer'
            href={linkLinkedIn}
            className={styles.Coordinates__content__infos__linkedIn}
          >
            <img
              width='80'
              src='/img/svg/icn-linkedin.svg'
              alt='LinkedIn ABECEDAIRE'
            />
          </a>
        </div>
        <ReactMapGL
          mapboxApiAccessToken='pk.eyJ1IjoiZGV2aGFuZHl0b3duIiwiYSI6ImNqN3lubW04ejY0eTkyd3FteHdkejMyZm4ifQ.QyW_3TnT010_iFFkPOSJ4w'
          {...viewport}
          onViewportChange={(nextViewport) => setViewport(nextViewport)}
          mapStyle='mapbox://styles/mapbox/dark-v10'
          height={'auto'}
        >
          <Marker
            latitude={49.44798435}
            longitude={1.09731068}
            offsetLeft={-20}
            offsetTop={-40}
          >
            <img
              className={styles.Coordinates__content__map__marker}
              src='/img/marker.png'
              alt=''
              width='80'
            />
          </Marker>
        </ReactMapGL>
      </div>
    </section>
  );
};

export default Coordinates;
